import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "popUpWrapper position-relative [ JS_ContentWrapper JS_accountWrapper ] hidden" };
const _hoisted_2 = { class: "wrapper_header px-3 py-4" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon-brand_close pointerhover",
    style: { "color": "#fff", "float": "right" }
}, null, -1);
const _hoisted_4 = { id: "ACCOUNT_HEADER_MENU" };
const _hoisted_5 = {
    key: 0,
    class: "desktopPopUpMyAccountWrapper_noLogin bg-white w-100"
};
const _hoisted_6 = { class: "col-12 myAccountNav myAccountNav_nologin" };
const _hoisted_7 = { class: "col-12 py-3 pointerhover bg-brand_beige_hover" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", {
    class: "row fc-brand_deep_blue",
    role: "button",
    title: "Anmelden",
    style: { "padding": "8px 4px 8px 16px" }
}, [
    /*#__PURE__*/ _createElementVNode("div", {
        "data-test": "cy-login-button",
        class: "col-10 p-0 text-left fc-brand_deep_blue",
        style: { "hyphens": "auto" }
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_user font5" }),
        /*#__PURE__*/ _createTextVNode(" Registrieren / Anmelden ")
    ])
], -1);
const _hoisted_9 = {
    key: 1,
    class: "desktopPopUpMyAccountWrapper_Login bg-white"
};
const _hoisted_10 = { class: "myAccountNav" };
import { computed } from 'vue';
import { useStore } from '@/store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DesktopMenu',
    setup(__props) {
        const store = useStore();
        const loggedIn = computed(() => store.state.account.currentUser !== null);
        return (_ctx, _cache) => {
            const _component_welcome_user = _resolveComponent("welcome-user");
            const _component_open_popup_button = _resolveComponent("open-popup-button");
            const _component_menu_items = _resolveComponent("menu-items");
            const _component_my_account_menu_items = _resolveComponent("my-account-menu-items");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_welcome_user),
                    _hoisted_3
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (!loggedIn.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("ul", _hoisted_6, [
                                _createElementVNode("li", _hoisted_7, [
                                    _createVNode(_component_open_popup_button, { "popup-name": "openLoginPopup" }, {
                                        default: _withCtx(() => [
                                            _hoisted_8
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_component_menu_items)
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("ul", _hoisted_10, [
                                _createVNode(_component_my_account_menu_items)
                            ])
                        ]))
                ])
            ]));
        };
    }
});
